import { useState } from 'react';
import { LayoutDashboard, Briefcase, MessageSquare, CalendarClock, Settings, Star, LogOut } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { useToast } from './Toast';
import logo from '../assets/logo.jpg';

const navItems = [
  { id: 'dashboard',    label: 'Dashboard',      icon: <LayoutDashboard size={20} /> },
  // { id: 'services',     label: 'Service Master',  icon: <Briefcase size={20} /> },
  { id: 'enquiries',    label: 'Enquiries',       icon: <MessageSquare size={20} /> },
  { id: 'demos',        label: 'Demo Schedules',  icon: <CalendarClock size={20} /> },
  { id: 'testimonials', label: 'Testimonials',    icon: <Star size={20} /> },
  { divider: true },
  { id: 'settings',     label: 'Settings',        icon: <Settings size={20} /> },
];

export default function Sidebar({ collapsed, activePage, onNavigate }) {
  const { logout, currentUser } = useApp();
  const toast = useToast();
  const [showConfirm, setShowConfirm] = useState(false);

  const handleLogoutConfirm = () => {
    setShowConfirm(false);
    toast.success('Logged Out', `Goodbye, ${currentUser?.name || 'Admin'}! See you soon.`);
    // slight delay so toast is visible before unmount
    setTimeout(() => logout(), 1200);
  };

  return (
    <>
      <aside className={`sidebar${collapsed ? ' collapsed' : ''}`}>

        {/* ── Header: logo ── */}
        <div className="sidebar-header">
          <div className="sidebar-logo-icon">
            <img src={logo} alt="MarketingScapers" />
          </div>
          <div className="sidebar-brand">
            Marketing<span>Scapers</span>
          </div>
        </div>

        {/* ── Nav items ── */}
        <nav className="sidebar-nav">
          {navItems.map((item, idx) => {
            if (item.divider) return (
              <div key={`divider-${idx}`} className="nav-divider" />
            );
            return (
              <div
                key={item.id}
                className={`nav-item${activePage === item.id ? ' active' : ''}`}
                onClick={() => onNavigate(item.id)}
              >
                <span className="nav-icon">{item.icon}</span>
                <span className="nav-label">{item.label}</span>
                {collapsed && <span className="nav-tooltip">{item.label}</span>}
              </div>
            );
          })}
        </nav>

        {/* ── Logout at bottom ── */}
        <div className="sidebar-footer">
          <div
            className="nav-item nav-item-logout"
            onClick={() => setShowConfirm(true)}
          >
            <span className="nav-icon"><LogOut size={20} /></span>
            <span className="nav-label">Logout</span>
            {collapsed && <span className="nav-tooltip">Logout</span>}
          </div>
        </div>

      </aside>

      {/* ── Logout confirm modal ── */}
      {showConfirm && (
        <div className="logout-overlay" onClick={() => setShowConfirm(false)}>
          <div className="logout-confirm" onClick={e => e.stopPropagation()}>
            <div className="logout-confirm-icon">
              <LogOut size={26} />
            </div>
            <h3 className="logout-confirm-title">Logout?</h3>
            <p className="logout-confirm-msg">
              Are you sure you want to logout from the admin panel?
            </p>
            <div className="logout-confirm-actions">
              <button className="btn btn-secondary" onClick={() => setShowConfirm(false)}>
                Cancel
              </button>
              <button className="btn btn-logout-confirm" onClick={handleLogoutConfirm}>
                Yes, Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
